import { createContext } from 'react';
import { useSafeContext } from '@mews-framework/utils';

interface AdaChatbotContextProps {
    start: () => Promise<void>;
    stop: () => Promise<void>;
    toggle: () => void;
    isStarted: boolean;
    isChatOpen: boolean;
    isChatButtonHidden: boolean;
    hideChatButton: () => void;
    showChatButton: () => void;
}
export const AdaChatbotContext = createContext<AdaChatbotContextProps | null>(null);

export const useAdaChatBotContext = () => useSafeContext(AdaChatbotContext);
